import { useModalContentToggler } from '@components'

import { Link, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { SubjectReconciliationModalStateId } from '../../../../../paymentReconciliationModal/enums/SubjectReconciliationModalStateId'

export const LinkToManualPayment = (): ReactElement => {
  const { t } = useTranslation()
  const { setActiveState } = useModalContentToggler()

  const handleLinkClick = useCallback(() => {
    setActiveState(SubjectReconciliationModalStateId.ManualPayment)
  }, [setActiveState])

  return (
    <>
      <Space size="s12" />
      <Text colorVariant="secondary">
        {t('bill.payment_reconcile.cant_find_bank_line')}{' '}
        <Text as="span">
          <Link onClick={handleLinkClick}>{t('bill.payment_reconcile.enter_without_reconciling')}</Link>
        </Text>
      </Text>
    </>
  )
}
